"use client";

import { useCallback } from "react";
import React from "react";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { ToggleButtons } from "ui/widget/toggle-buttons";

import { PerformanceDate, performanceDate } from "../data/performance-date";

type Props = {
  date: PerformanceDate;
};

export const DateButtons = React.memo(({ date }: Props) => {
  const { updateQuery } = useUpdateQuery();

  const handleChange = useCallback(
    (value: string) => {
      updateQuery({ name: "performance", value });
    },
    [updateQuery]
  );

  return (
    <ToggleButtons
      aria-label="performance date"
      itemClassName="rounded-lg px-1 min-w-10 text-zinc-500 hover:text-zinc-800"
      selectedItemClassName="bg-sky-100 shadow-none font-bold text-sky-600 hover:text-inset"
      options={performanceDate.map((option) => ({ value: option }))}
      value={date}
      onChange={handleChange}
      fullWidth={false}
    />
  );
});
